export const INVOICE_FRANCHISE_COLUMNS: Record<string, string[]> = {
  Alphabet: [
    'warehouse',
    'customer',
    'documentNumber',
    'contractNumber',
    'unitType',
    'rentWithoutVat',
    'unitVat',
    'unit',
    'insuranceWithoutVat',
    'insuranceVat',
    'insurance',
    'deposit',
    'lateCharge',
    'otherWithoutVat',
    'otherVat',
    'other',
    'amountWithoutVat',
    'vatAmount',
    'paymentTransactionId',
    'debt',
    'contractStatus',
    'description',
    'refunds',
    'refundMethods',
    'creditNotes',
    'createdAt',
  ],
  FAGA: [
    'warehouse',
    'customer',
    'documentNumber',
    'contractNumber',
    'unitType',
    'rentWithoutVat',
    'unitVat',
    'unit',
    'insuranceWithoutVat',
    'insuranceVat',
    'insurance',
    'deposit',
    'lateCharge',
    'otherWithoutVat',
    'otherVat',
    'other',
    'amountWithoutVat',
    'vatAmount',
    'paymentTransactionId',
    'debt',
    'contractStatus',
    'description',
    'refunds',
    'refundMethods',
    'creditNotes',
    'createdAt',
  ],
  'Rentabox24 PL': [
    'warehouse',
    'documentNumber',
    'contractNumber',
    'unitType',
    'rentWithoutVat',
    'unitVat',
    'unit',
    'insuranceWithoutVat',
    'insuranceVat',
    'insurance',
    'deposit',
    'lateCharge',
    'otherWithoutVat',
    'otherVat',
    'other',
    'amountWithoutVat',
    'vatAmount',
    'paymentTransactionId',
    'debt',
    'contractStatus',
    'description',
    'refunds',
    'refundMethods',
    'creditNotes',
    'createdAt',
    'customer',
    'phone',
    'email',
    'country',
    'city',
    'street',
    'house',
    'apartment',
    'zipCode',
    'amount',
    'paymentMethods',
    'pm_online_payment',
    'pm_bank_transfer',
    'pm_user_balance',
    'pm_cash',
    'pm_terminal_payment',
    'pm_deposit',
    'pm_other',
    'payments',
    'dueDate',
    'dateFrom',
    'dateTo',
  ],
  'Rentabox24 AT': [
    'warehouse',
    'documentNumber',
    'contractNumber',
    'unitType',
    'rentWithoutVat',
    'unitVat',
    'unit',
    'insuranceWithoutVat',
    'insuranceVat',
    'insurance',
    'deposit',
    'lateCharge',
    'otherWithoutVat',
    'otherVat',
    'other',
    'amountWithoutVat',
    'vatAmount',
    'paymentTransactionId',
    'debt',
    'contractStatus',
    'description',
    'refunds',
    'refundMethods',
    'creditNotes',
    'createdAt',
    'customer',
    'phone',
    'email',
    'country',
    'city',
    'street',
    'house',
    'apartment',
    'zipCode',
    'amount',
    'paymentMethods',
    'pm_online_payment',
    'pm_bank_transfer',
    'pm_user_balance',
    'pm_cash',
    'pm_terminal_payment',
    'pm_deposit',
    'pm_other',
    'payments',
    'dueDate',
    'dateFrom',
    'dateTo',
  ],
  Swissbox: [
    'warehouse',
    'documentNumber',
    'contractNumber',
    'unitType',
    'rentWithoutVat',
    'unitVat',
    'unit',
    'insuranceWithoutVat',
    'insuranceVat',
    'insurance',
    'deposit',
    'lateCharge',
    'otherWithoutVat',
    'otherVat',
    'other',
    'amountWithoutVat',
    'vatAmount',
    'paymentTransactionId',
    'debt',
    'contractStatus',
    'description',
    'refunds',
    'refundMethods',
    'creditNotes',
    'createdAt',
    'customer',
    'phone',
    'email',
    'country',
    'city',
    'street',
    'house',
    'apartment',
    'zipCode',
    'amount',
    'paymentMethods',
    'pm_online_payment',
    'pm_bank_transfer',
    'pm_user_balance',
    'pm_cash',
    'pm_terminal_payment',
    'pm_deposit',
    'pm_other',
    'payments',
    'dueDate',
    'dateFrom',
    'dateTo',
  ],
};
